import axios from 'axios'
import { store, vuexTypes } from '@/vuex'

// thanx to https://github.com/trevorwang/vue-auth-image

export async function setImgSrc (el, binding) {
  if (binding.oldValue === undefined || binding.value !== binding.oldValue) {
    const imageUrl = binding.value
    const authToken = store.getters[vuexTypes.authToken]

    const config = {
      headers: {
        'Authorization': authToken,
      },
      method: 'GET',
      responseType: 'arraybuffer',
    }
    try {
      const response = await axios(imageUrl, config)
      const mimeType = response.headers['content-type'].toLowerCase()

      const imgBase64 = Buffer.from(response.data, 'binary').toString('base64')
      const src = 'data:' + mimeType + ';base64,' + imgBase64

      if (response.headers['content-type'] === 'application/pdf') {
        const downloadLink = document.createElement('a')

        const fileName = `${el.title}.pdf`

        downloadLink.href = src
        downloadLink.innerHTML = fileName
        downloadLink.download = fileName

        el.parentNode.appendChild(downloadLink)

        el.parentNode.removeChild(el)
      } else {
        el.src = src
      }
    } catch (err) {
      el.src = imageUrl
    }
  }
}

export const vueAuthImageDirective = {
  bind: function (el, binding) {
    setImgSrc(el, binding)
  },
  componentUpdated: function (el, binding) {
    setImgSrc(el, binding)
  },
}
